export default __webpack_public_path__ + "static/media/logo.f3b88a80.svg";